import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "1%",
    paddingLeft: "2%",
    color: "white",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  red: {
    background: "orange",
  },
}));

export default function AlertaCC({ permisoCC, esencialCC, reestriccionCC }) {
  const classes = useStyles();

  function alert(mensaje, colorFondo) {
    return (
      <div className={classes.root} style={{ background: colorFondo }}>
        <List component="nav" aria-label="main mailbox folders">
          <ListItem button>
            <ListItemIcon style={{ color: "white" }}>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText primary={mensaje} />
          </ListItem>
        </List>
      </div>
    );
  }

  return (
    <>
      {!permisoCC
        ? alert("Usted no posee Certificado de Circulación.", "#ff5c5cfc")
        : !esencialCC
        ? alert("Usted no esta dentro de Actividades esenciales.", "orange")
        : ""}

      {reestriccionCC
        ? alert(
            `Usted puede reservar servicios desde ${moment(
              reestriccionCC.desde
            ).format("DD/MM/YYYY HH:mm")} hasta ${moment(
              reestriccionCC.hasta
            ).format("DD/MM/YYYY HH:mm")}`,
            "orange"
          )
        : ""}
    </>
  );
}
